<template>
  <div>
    <page-header
      :actions="pageActionConfig"
      class="custom-page-header"
      left-side-class="col-xl-4"
      :page="pageConfig"
      right-side-class="col-xl-8 align-items-end d-flex pb-2 justify-content-end"
    />

    <create-journal
      v-if="showCreateJournal"
      :academic-years="catalog.academicYears"
      @on-cancel="onCancelHandler"
      @on-continue="onContinueHandler"
    />

    <filter-manager
      ref="attendanceFilterRef"
      v-model="filterModel"
      class="mb-4 filter-manager-extended"
      :display-advanced="false"
      :filters="filterManagerConfig"
      @search="onSearchHandler"
    />
    <custom-separator class="pt-3 my-4" text="Resultado de Jornal de Pagos" />
    <custom-result-not-found v-if="result.data.length === 0" />
    <search-result :result="result" @on-page-change="onPageChangeHandler" />
  </div>
</template>
<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import SearchResult from './SearchResult';
import { CreateJournal } from './components';
import {
  getJournalInitFilters as _getJournalInitFilters,
  getJournal as _getJournal,
  createPaymentJournal as _createPaymentJournal,
} from '@/modules/shared/scholarship.api.js';

import { getAcademicYearsWithLoadProcess as _getAcademicYearsWithLoadProcess } from '@/modules/shared/academicyear.api.js';

import alertMixin from 'utils/mixins/alert.mixin.js';
import storeMixin from 'utils/mixins/storeGenerator';
import paymentJournalStatus from '@/utils/constants/paymentJournalStatus.js';

const PAGE_SIZE = 15;
const STORE_MODULE_NAME = 'PaymentJournalModule';

export default {
  name: 'Main',
  components: {
    PageHeader,
    FilterManager,
    CustomSeparator,
    CustomResultNotFound,
    SearchResult,
    CreateJournal,
  },
  mixins: [alertMixin, storeMixin],
  data: () => ({
    moduleName: STORE_MODULE_NAME,
    filterModel: {},
    catalog: {},
    result: {
      data: [],
      pagination: {},
    },
    showCreateJournal: false,
  }),
  computed: {
    pageConfig() {
      return {
        icon: 'fas fa-book',
        title: 'Jornal de Pagos',
        routes: ['Inicio', 'Becas', 'Jornal de Pagos'],
      };
    },
    pageActionConfig() {
      return [
        {
          text: 'Crear Jornal',
          icon: 'fas fa-file-plus',
          variant: 'success',
          click: this.onCreateHandler,
          class: 'mt-4',
          visible: this.userHasPermissions(
            'menu.scholarship.jornalpayment.create'
          ),
        },
      ];
    },
    filterManagerConfig() {
      return [
        {
          component: 'CustomDropDown',
          name: 'academicYear',
          options: this.catalog.academicYears,
          placeholder: 'Seleccione el año académico',
          fieldKey: 'id',
          class: 'col-md-4',
          fieldName: 'name',
          clearable: false,
        },
        {
          component: 'CustomDropDown',
          name: 'status',
          options: this.catalog.status,
          placeholder: 'Seleccione estatus',
          fieldKey: 'id',
          class: 'col-md-4',
          fieldName: 'name',
          clearable: true,
        },
      ];
    },
  },
  destroyed() {
    this.persistData();
  },
  mounted() {
    this.loadInitFilters();
    if (this.result.data.length > 0) {
      this.callSearchJournal();
    }
  },
  methods: {
    async loadInitFilters() {
      const { data } = await _getJournalInitFilters();

      const {
        data: loadAcademicYears,
      } = await _getAcademicYearsWithLoadProcess();

      this.catalog = {
        ...data.collections,
        academicYears: loadAcademicYears,
      };

      this.filterModel = {
        ...data.filters,
        ...this.filterModel,
      };
      this.filterModel.academicYear = data.filters.academicYear;
      this.callSearchJournal();
    },
    onCreateHandler() {
      this.showCreateJournal = true;
    },
    async onContinueHandler({ academicYear }) {
      if (academicYear) {
        const re = await _getJournal(academicYear.id);

        if (re) {
          const { data } = re.data;

          var hasNuevo = data.some(
            (item) => item.paymentJournalStatusId === paymentJournalStatus.Nuevo
          );

          if (hasNuevo) {
            this.ShowToast(
              '',
              'Ya existe un jornal en estatus Nuevo para el año seleccionado, favor actualizarlo en el detalle del jornal nuevo.',
              'error'
            );

            return false;
          }
        }

        const response = await _createPaymentJournal(academicYear.id).catch(
          (err) => {
            this.ShowToast('', err.response.data.message, 'error');
          }
        );

        if (response) {
          this.ShowToast(
            'Proceso Exitoso',
            'El jornal de pago ha sido creado exitosamente.',
            'success'
          );
          this.onCancelHandler();

          //search by selected academicYear
          this.filterModel.academicYear = academicYear;
          this.callSearchJournal();
        }
      }
    },
    onCancelHandler() {
      this.showCreateJournal = false;
    },
    async onSearchHandler() {
      this.callSearchJournal();
    },
    async callSearchJournal(pageIndex = 1) {
      const { data: response } = await _getJournal(
        this.filterModel.academicYear.id,
        this.filterModel.status?.id ?? null,
        pageIndex
      );
      this.result = {
        data: response.data,
        pagination: {
          currentPage: response.currentPage,
          totalItemCount: response.totalItemCount,
          pageCount: response.pageCount,
          count: response.count,
          perPage: PAGE_SIZE,
        },
      };
    },
    onPageChangeHandler(page) {
      this.callSearchJournal(page);
    },
  },
};
</script>

<style scoped lang="scss">
@media only screen and (max-width: 768px) {
  ::v-deep .custom-page-header {
    .actions {
      display: flex !important;
      justify-content: flex-end !important;
    }
  }

  ::v-deep .filter-manager-extended {
    .d-flex {
      display: flex !important;
      justify-content: flex-end !important;
      margin-right: 20px;
    }
  }
}
</style>
